import { cssThemedValue } from '@creditornot/cb-ingredients';
import { ModalFooter } from '@creditornot/cb-modal';
import styled, { css } from 'styled-components';

export const NoteContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
`;

export const VenueList = styled.div`
  background: ${cssThemedValue('surfaceMain')};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  flex: 1 1 auto;
  overflow-y: auto;
`;

export const VenueItemRoot = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  flex-shrink: 0;
  overflow: hidden;
  white-space: nowrap;
  & + & {
    border-block-start: 1px solid ${cssThemedValue('borderPrimary')};
  }
`;

export const VenueItemLeftContent = styled.div`
  display: flex;
  align-items: center;
`;

export const VenueItemRightContent = styled.div``;

export const NameAndAddress = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ImageContainer = styled.div<{ $addInlineStartMargin?: boolean }>`
  margin-inline-end: 12px;
  border-radius: 50%;

  img {
    object-fit: cover;
  }

  ${({ $addInlineStartMargin }) =>
    !!$addInlineStartMargin &&
    css`
      margin-inline-start: 12px;
    `}
`;

export const StyledModalFooter = styled(ModalFooter)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
